<template>
    <HeadlessPopover v-slot="{ open }" class="flex h-full">
        <slot name="popover-button" :open="open"></slot>

        <transition
            enter-active-class="duration-500 ease-out"
            enter-from-class="opacity-0"
            enter-to-class="opacity-100"
            leave-active-class="duration-150 ease-in"
            leave-from-class="opacity-100"
            leave-to-class="opacity-0"
        >
            <HeadlessPopoverOverlay
                class="fixed inset-x-0 bottom-0 top-[61px] z-[5] bg-gray-900 opacity-40"
            />
        </transition>

        <Transition
            enter-active-class="transition-[max-height] duration-700 ease"
            enter-from-class="max-h-0"
            enter-to-class="max-h-[600px]"
            leave-active-class="transition-[max-height] duration-[500ms] ease"
            leave-from-class="max-h-[600px]"
            leave-to-class="max-h-0"
        >
            <!-- unmount option (display:hidden; instead of v-if) ensures that
                panels with indexable pages are always in the initial markup (SEO) -->
            <HeadlessPopoverPanel
                v-slot="{ close }"
                :unmount="false"
                class="absolute inset-x-0 top-[61px] z-10 overflow-hidden bg-white"
            >
                <slot name="panel" :close="close"></slot>
            </HeadlessPopoverPanel>
        </Transition>
    </HeadlessPopover>
</template>
